export const isActionEnabled = (enable) => enable === 1 || enable === true || enable === '1';

export const isPersistedActionId = id => Boolean(id) && !String(id).startsWith('temp_');

export const matchesActionResponse = (payload, { id, caseid, idKey = 'id' }) => (
  payload?.[idKey] != null && id != null && String(payload[idKey]) === String(id)
  && (payload.caseid == null || String(payload.caseid) === String(caseid))
);

export const parseActionCustomData = (value) => {
  if (!value) return {};
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (error) {
      console.error('Failed to parse action customData:', error);
      return {};
    }
  }
  return typeof value === 'object' && !Array.isArray(value) ? value : {};
};

export const normalizeActionSettingsPayload = (payload = {}) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return { customData: {} };
  const customData = parseActionCustomData(payload.customData ?? payload.data);
  return {
    ...payload,
    customData,
    // Keep legacy loaders and current forms on the same confirmed version.
    data: typeof payload.data === 'string' ? JSON.stringify(customData) : customData,
  };
};

export const getActionSettingValue = (data, path) => String(path).split('.').reduce(
  (value, key) => value && typeof value === 'object'
    && Object.prototype.hasOwnProperty.call(value, key) ? value[key] : undefined,
  data,
);

export const shouldPersistActionImmediately = (actionType) => (
  String(actionType || '').trim().toLowerCase() !== 'humaninloop'
);

export const mergeSavedActionData = (actionType, existingData, savedData) => {
  const existing = existingData && typeof existingData === 'object' && !Array.isArray(existingData)
    ? existingData
    : {};
  const saved = savedData && typeof savedData === 'object' && !Array.isArray(savedData)
    ? savedData
    : {};

  if (String(actionType || '').trim().toLowerCase() === 'widgetagent') {
    return { ...saved };
  }

  return { ...existing, ...saved };
};

export const buildGetExportSettingsPayload = (exportId, caseid) => ({
  command: 'getExportSettings',
  export_id: exportId,
  caseid
});
